import { render, staticRenderFns } from "./Bridging.vue?vue&type=template&id=a0607e9a"
import script from "./Bridging.vue?vue&type=script&lang=js"
export * from "./Bridging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports